export default {
	escapeKey: 'Escape'
}
